export const mutations = {
    SET_AVAILABLE_SVG_FILES(state, availableSvgFiles) {
        state.availableSvgFiles = availableSvgFiles;
    },
    SET_UI_FILTERS(state, data) {
        // check if data already exists in the array
        const filter = state.uiFilters.find((d) => {
            return (d.id === data.id);
        });

        // add data to the array or change the existing entry
        if (filter === undefined) {
            state.uiFilters.push(data);
        } else {
            filter.value = data.value;
        }
    }
};
